import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject;
var FlagContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  ", ";\n  ", ";\n"])), function (_ref) {
  var $width = _ref.$width;
  return "width: ".concat($width);
}, function (_ref2) {
  var $height = _ref2.$height;
  return "height: ".concat($height);
});

export { FlagContainer };
//# sourceMappingURL=Flag.styles.js.map
